import React from "react";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { FormatCurrencyLKR } from "../../utils/common/CurrencyFormatter";

/**
 * Reusable component for displaying billing information
 * @param {Array} billingDetails - Array of billing line items
 * @param {string} totalLabel - Label for total row
 * @param {string|number} totalValue - Value for total row
 * @param {Object} customStyles - Optional custom styles
 */
function BillingInfo({
  billingDetails = [],
  totalLabel = "Total Invoice Value",
  total = "Total Invoice Value",
  totalValue = "0.00",
  customStyles = {}
}) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const formatLineValue = (value) => {
    // Preserve non-numeric/custom values as-is
    if (value === null || value === undefined || value === "") return "0.00";

    const numericValue = Number(value);

    if (Number.isNaN(numericValue)) {
      return value;
    }

    return FormatCurrencyLKR(numericValue);
  };

  return (
    <Grid container spacing={2} py={2}>
      {billingDetails.map((item, index) => (
        <React.Fragment key={index}>
          <Grid
            item
            size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
            sx={{ ...styles.grn_bill_content, ...customStyles.labelGrid }}
          >
            <Typography sx={{ ...styles.grn_bill_name, ...customStyles.label }}>
              {item.label}
            </Typography>
          </Grid>
          <Grid
            item
            size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
            style={{ textAlign: "right" }}
          >
            <Typography sx={{ ...styles.grn_bill_name, ...customStyles.value }}>
              {formatLineValue(item.value)}
            </Typography>
          </Grid>
        </React.Fragment>
      ))}
   <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
        <Typography sx={{ ...styles.grn_bill_name, ...customStyles.value }}>
          {total}
        </Typography>
      </Grid>
      <Grid
        item
        size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
        style={{ textAlign: "right" }}
      >
       <Typography sx={{ ...styles.grn_bill_name, ...customStyles.value }}>
          {FormatCurrencyLKR(totalValue)}
        </Typography>
      </Grid>
      {/* Divider */}
      <Grid item size={{ xs: 12 }}>
        <hr style={{ border: 'none', borderTop: '1px solid #e0e0e0', margin: '16px 0' }} />
      </Grid>

      {/* Total */}
      <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
        <Typography variant="subtitle1" fontWeight="bold">
          {totalLabel}
        </Typography>
      </Grid>
      <Grid
        item
        size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
        style={{ textAlign: "right" }}
      >
        <Typography variant="subtitle1" fontWeight="bold">
          {FormatCurrencyLKR(totalValue)}
        </Typography>
      </Grid>
    </Grid>
  );
}

export default BillingInfo;
